import React, { useState, useRef, useEffect, useCallback } from 'react';
import styles from './Accordion.module.scss';

interface AccordionProps {
  title?: string;
  text?: string;
  img?: string;
}

export const Accordion: React.FC<AccordionProps> = ({ title, text, img }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement | null>(null);

  const calculateHeight = useCallback(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, []);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      calculateHeight();
    }
  };

  useEffect(() => {
    calculateHeight();
  }, [calculateHeight]);

  const handleImageLoad = () => {
    calculateHeight();
  };

  return (
    <div className={styles.accordion}>
      <button
        className={styles.accordionHeader}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        aria-controls="accordion-content"
        id="accordion-header"
      >
        <div className={styles.accordionHeaderTitleWrapper}>
          <p className={styles.accordionHeaderTitle}>{title}</p>
        </div>
        <div className={styles.toggle}></div>
      </button>
      <div
        className={`${styles.accordionContent} ${isOpen ? styles.open : ''}`}
        id="accordion-content"
        role="region"
        aria-labelledby="accordion-header"
        ref={contentRef}
        style={{ height: isOpen ? `${height}px` : '0px' }}
      >
        {text && (
          <div
            dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }}
          />
        )}
        {img && (
          <figure className={styles.imgWrapper}>
            <img src={img} alt={title} onLoad={handleImageLoad} />
          </figure>
        )}
      </div>
    </div>
  );
};